<template>
    <div class="App">
      <router-view></router-view>
      <v-snackbar
        v-model="snackbar.showing"
        :timeout="snackbar.timeout"
        :color="snackbar.color"
      >
        {{ snackbar.text }}

        <template v-slot:action="{ attrs }">
          <v-btn
            :color="snackbar.btncolor"
            text
            v-bind="attrs"
            @click="snackbar.showing = false"
          >
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <!-- <Autologout></Autologout> -->
    </div>
</template>

<script>
import {mapState} from 'vuex'
import { startSessionWatch, flushExpiredNotice } from '@/services/session'
import { loadTheme } from '@/services/theme'
// import Autologout from '@/components/Autologout/autologout'
export default {
  name: 'App',
  components: {
    // Autologout
  },
  data: () => ({
  }),
  created() {
    // Show the "session expired" toast if we were just redirected here,
    // and start watching the token so idle pages also detect expiry.
    flushExpiredNotice()
    startSessionWatch()
    // Kick off the configurable palette here so the CSS custom properties are
    // set before the first table paints. Fire-and-forget: every var and every
    // consumer carries the shipped default, so a slow or failed fetch just
    // leaves the stock colours in place.
    loadTheme()
  },
  computed: {
    ...mapState(['snackbar'])
  }
};
</script>
